// Pricing Page
export default function Pricing() { return <div><h1 className="text-4xl font-bold text-center py-20">Pricing</h1><p className="text-center">Membership and class pricing options.</p></div>; }